import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "ant-table-column-title" }
const _hoisted_2 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_3 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px"}
}
const _hoisted_11 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_12 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px"}
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, null, -1)
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
      retornoRequisicao: _ctx.modalBase.retornoRequisicao
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"]),
    _createVNode(_component_a_dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.defineSaldoFinalComSomaTodasContagens())),
              key: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "mais" }),
                _createTextVNode(" Soma todas as contagens de todos os produtos e aplica as quantidades no Saldo Final.")
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.conferentes, (conferente) => {
              return (_openBlock(), _createBlock(_component_a_menu_item, {
                key: (conferente.codigo +1),
                onClick: ($event: any) => (_ctx.defineSaldoFinalContagemEspecifica(conferente.codigo))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icone, { nome: "correto" }),
                  _createTextVNode(" Definir no saldo final da contagem realizada por: "),
                  _createElementVNode("b", null, _toDisplayString(conferente.textoIdentificacao), 1),
                  _createTextVNode(" em todos os produtos.")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, { class: "ant-btn ant-btn-primary ss-alinhar-direita" }, {
          default: _withCtx(() => [
            _createTextVNode(" Ações em massa ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_component_a_table, {
      key: _ctx.computedCodigoBalancoEstoque,
      columns: _ctx.gradeBase.colunas.filter(item => item.visible),
      "data-source": _ctx.state.itens,
      rowKey: "codigoItemBalanco",
      pagination: false,
      scroll: { x: _ctx.state.larguraGrade },
      loading: _ctx.gradeBase.buscandoDados,
      size: "small"
    }, {
      headerCell: _withCtx(({ column }) => [
        (column.ordering)
          ? (_openBlock(), _createElementBlock("div", {
              key: column.key,
              class: "ss-coluna-ordenada"
            }, [
              _createElementVNode("span", _hoisted_1, _toDisplayString(column.title), 1),
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(), _createElementBlock("a", {
                    title: "Ordenação crescente",
                    key: 'ord-asc' + column.key,
                    class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                    onClick: ($event: any) => (_ctx.ordenarDados(column.key,'ASC'))
                  }, _hoisted_6, 10, _hoisted_4)),
                  (_openBlock(), _createElementBlock("a", {
                    title: "Ordenação decrescente",
                    key: 'ord-desc' + column.key,
                    class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                    onClick: ($event: any) => (_ctx.ordenarDados(column.key,'DESC'))
                  }, _hoisted_9, 10, _hoisted_7))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      bodyCell: _withCtx(({ column, record }) => [
        (column.key.includes(_ctx.chaveContagemUsuario))
          ? (_openBlock(), _createElementBlock("span", {
              class: "ant-input-wrapper ant-input-group ss-alinhar-texto-direita",
              key: record.codigo
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_a_tooltip, {
                  placement: "top",
                  title: "Define o valor desta contagem como saldo final!"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, {
                      checked: record.itemRevisado,
                      "onUpdate:checked": ($event: any) => ((record.itemRevisado) = $event),
                      onChange: ($event: any) => (_ctx.sincronizarInformacoesRevisao(record.codigo,record.codigoItemBalanco,_ctx.obtemQuantidadeContagem(record,column.key),record.observacoes))
                    }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_campo_numerico, {
                disabled: true,
                valor: _ctx.obtemQuantidadeContagem(record,column.key),
                quantidadeCasasDecimais: record.casasDecimais
              }, null, 8, ["valor", "quantidadeCasasDecimais"])
            ]))
          : (column.key === 'Observacoes')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": ($event: any) => ((record.observacoes) = $event),
                onBlur: ($event: any) => (_ctx.sincronizarInformacoesRevisao(record.codigo,record.codigoItemBalanco,record.quantidadeRevisada, ($event.target as HTMLInputElement).value))
              }, null, 40, _hoisted_11)), [
                [_vModelText, record.observacoes]
              ])
            : (column.key === 'SaldoFinal')
              ? (_openBlock(), _createElementBlock("span", {
                  key: record.codigoBalancoEstoqueItem,
                  class: "ant-input-wrapper ant-input-group ss-alinhar-texto-direita"
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Soma todas as contagens e define o saldo final."
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-primary ant-btn-block",
                          style: {"height":"30px","width":"30px","padding":"4px 5px"},
                          onClick: ($event: any) => (_ctx.sincronizarInformacoesRevisao(record.codigo,record.codigoItemBalanco,_ctx.obtemSomaTodasContagens(record),record.observacoes))
                        }, [
                          _createVNode(_component_icone, { nome: "mais" })
                        ], 8, _hoisted_13)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createVNode(_component_campo_numerico, {
                    valor: record.quantidadeRevisada,
                    "onUpdate:valor": ($event: any) => ((record.quantidadeRevisada) = $event),
                    quantidadeCasasDecimais: record.casasDecimais,
                    onBlur: ($event: any) => (_ctx.sincronizarInformacoesRevisao(record.codigo,record.codigoItemBalanco,record.quantidadeRevisada,record.observacoes))
                  }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais", "onBlur"])
                ]))
              : _createCommentVNode("", true)
      ]),
      emptyText: _withCtx(() => [
        _createVNode(_component_mensagem_sem_dados, {
          adicionarDado: true,
          mensagem: _ctx.gradeBase.buscandoDados?'Buscando informações, por favor aguarde...':'Nenhum item encontrado, verifique se os conferentes inciaram as contagens.'
        }, null, 8, ["mensagem"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "scroll", "loading"])),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_totalizador, {
          titulo: "TOTAL ITENS",
          valor: _ctx.state.estatisticasRevisao.quantidadeItens,
          monetario: false
        }, null, 8, ["valor"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_totalizador, {
          titulo: "AGUARDANDO REVISÃO",
          valor: _ctx.state.estatisticasRevisao.aguardandoRevisao,
          monetario: false
        }, null, 8, ["valor"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_totalizador, {
          titulo: "REVISADOS",
          valor: _ctx.state.estatisticasRevisao.revisados,
          monetario: false
        }, null, 8, ["valor"])
      ])
    ], 512), [
      [_vShow, (!_ctx.gradeBase.buscandoDados)]
    ])
  ]))
}